import { createFileRoute } from "@tanstack/react-router";
import Component from "@/layouts/layout/component";
import { Loading } from "@/layouts/loading";

export const Route = createFileRoute('/(app)/_layout')({
    component: Component,
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
}); 